import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
	name: "user",
	initialState: {
		userInfo: {
			name: "",
			email: "",
		},
		userLoggedIn: false,
	},
	reducers: {
		setUserLoggerdIn: (state) => {
			state.userLoggedIn = true;
		},
		setUserLoggerdOut: (state) => {
			state.userLoggedIn = false;
			state.userInfo.email = "";
			state.userInfo.name = "";
		},
		setUserInfo: (state, action) => {
			state.userInfo = {
				name: action.payload?.name ?? "",
				email: action.payload?.email ?? "",
			};
		},
	},
});

export const { setUserLoggerdIn, setUserLoggerdOut, setUserInfo } =
	userSlice.actions;
